define(function (require) {
    "use strict";

    var LE = require("app");

    var SpecialOccasionEventsComparators = [];

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        SpecialOccasionEventsComparators = [
            {
                name:"timeFrame",
                func:function(model){
                    var endDate = model.getEndDate();
                    var startDate = model.getStartDate();

                    return (!_.isNull(startDate) && !_.isNull(endDate)) ? [startDate.getTime(), endDate.getTime()] : null;
                }
            }
        ];
    });

    return SpecialOccasionEventsComparators;
});
